module.exports = __webpack_public_path__ + "img/P47-en.bb327570.png";